module.exports = __webpack_public_path__ + "img/A0104.b6e7f549.png";